import { render, staticRenderFns } from "./hrd-add-accreditor.vue?vue&type=template&id=327a7035&scoped=true"
import script from "./hrd-add-accreditor.vue?vue&type=script&lang=js"
export * from "./hrd-add-accreditor.vue?vue&type=script&lang=js"
import style0 from "./hrd-add-accreditor.vue?vue&type=style&index=0&id=327a7035&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a7035",
  null
  
)

export default component.exports